import { ref, computed, type Ref } from 'vue';

export class Pager {
  public enabled: Ref<boolean>;
  public pageSize: Ref<number>;
  public currentPage: Ref<number>;
  public totalSize: Ref<number>;

  constructor(options: {
    enabled: boolean;
    totalSize: number;
    pageSize: number;
  }) {
    this.enabled = ref(options.enabled || false);
    this.totalSize = ref(options.totalSize || 0);
    this.pageSize = ref(options.pageSize || 10);
    this.currentPage = ref(1);
  }

  public setTotalSize(size: number) {
    this.totalSize.value = size;
    const maxPage = Math.ceil(size / this.pageSize.value) || 1;
    if (this.currentPage.value > maxPage) {
      this.currentPage.value = maxPage;
    }
  }

  public currentPageSlice(rows: any[]) {
    if (!this.enabled.value) {
      return rows;
    }

    const start = (this.currentPage.value - 1) * this.pageSize.value;
    const end = start + this.pageSize.value;
    return rows.slice(start, end);
  }

  public get state() {
    const startPos = (this.currentPage.value - 1) * this.pageSize.value + 1;
    const endPos = Math.min(
      startPos + this.pageSize.value - 1,
      this.totalSize.value,
    );
    return {
      startPos: this.totalSize.value === 0 ? 0 : startPos,
      endPos,
      totalSize: this.totalSize.value,
    };
  }
}
